<template>
  <svg
    class="o-icon"
    width="24"
    height="24"
    focusable="false"
    :role="role"
    :aria-label="label"
  >
    <use :xlink:href="`${baseUrl}img/icons.svg#icon-${name}`"></use>
  </svg>
  <!-- /o-icon -->
</template>

<script>
  export default {
    name: 'icon',
    props: {
      name: {
        type: String,
        required: true,
      },
      role: {
        type: String,
        default: 'presentation',
      },
      label: {
        type: String,
      },
    },
  };
</script>



// WEBPACK FOOTER //
// Icon.vue?7cc995e7